import React, { useCallback, useState } from "react";
import { Card, Button, Col, Row, CardBody, CardFooter } from "reactstrap";
import closeOutline from "../../../assets/icons/close-outline.svg";
import store from "../../../assets/icons/store.svg";

import I18n from "../../../../i18n/utils";
import CFASpinner from "../../Common/CFASpinnner/CFASpinner";
import success from "../../../assets/icons/success-icon.svg";
import "./riskInformationMultiSelectModal.scss";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { getUserPermissions } from "../../../utils/LocalStorage";
import {
  Slider,
  SliderChangeCommittedCallbackType,
} from "cfa-react-components";

function RiskInformationSaveModal(props: any) {
  const [validationError, setValidationError] = useState<string>("");
  const [value, setValue] = useState<number>(0);

  const close = useCallback(() => {
    props.close(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeSuccess = useCallback(() => {
    props.close(true);
  }, []);

  let error = false;

  const errorStatus = useSelector(
    (state: RootState) => state.refundAnalysisInformation.saveAllStatus
  );

  const checkUserPerms = () => {
    const treasuryPermissions = getUserPermissions();
    return (
      treasuryPermissions.hasOwnProperty("SHERLOCK_ADMIN") ||
      treasuryPermissions.hasOwnProperty("SUPERUSER")
    );
  };

  if (errorStatus === "failed") {
    error = true;
  }

  const marks = [
    {
      value: 1,
      label: "1",
    },
    {
      value: 2,
      label: "2",
    },
    {
      value: 3,
      label: "3",
    },
    {
      value: 4,
      label: "4",
    },
    {
      value: 5,
      label: "5",
    },
  ];

  const errorMessage = useSelector(
    (state: RootState) => state.refundAnalysisInformation.error
  );

  const handleChange: SliderChangeCommittedCallbackType = (
    _event,
    newValue
  ) => {
    // @ts-ignore
    const userSelectedRiskScore: number = parseInt(newValue);
    setValue(userSelectedRiskScore);
  };

  const saveAndCloseModal = () => {
    let parent = props.gridRef.current.api.getRowNode(
      props.parentNode.context.masterGrid.data.locationNumber
    );
    parent.detailNode.detailGridInfo.api?.forEachNodeAfterFilter(
      (node: any) => {
        node.setDataValue("refundAnomalyScoreRead.riskLevel", value);
        props.addScoreToModifiedData(node.data);
      }
    );
    close();
  };

  const saveForm = (
    <Row>
      <Col className="dashboard-card">
        <Card className="dashboard-card">
          <CardBody>
            <Row className="close-button-container">
              <img
                alt=""
                src={closeOutline}
                className="close-modal-icon"
                onClick={close}
              />
            </Row>
            <Row className="container">
              <Col className="bu-override-import-title-container">
                <img
                  alt=""
                  src={store}
                  className="bu-override-import-title-icon"
                />
                <h2 className="bu-override-import-title">
                  {I18n.t("RISK_ANALYSIS_SET_RISK_SCORE_MODAL_TITLE")}
                </h2>
              </Col>
            </Row>
            <Row className="input-row">
              <Slider
                min={0}
                max={5}
                step={1}
                marks={marks}
                defaultValue={0}
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  margin: "auto",
                }}
                crossOrigin={undefined}
                onChange={handleChange}
                color="secondary"
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            </Row>
            {validationError && (
              <Row>
                <h4 className="error">{validationError}</h4>
              </Row>
            )}
            <CardFooter>
              {!props.loading ? (
                <Row style={{ marginTop: 30 }}>
                  <br />
                  <>
                    <Button
                      disabled={value === 0 || !checkUserPerms()}
                      className="submit-button"
                      onClick={saveAndCloseModal}
                    >
                      {I18n.t(
                        "APP_BUSINESS_UNIT_OVERRIDES_IMPORT_FILE_SUBMIT_TEXT"
                      )}
                    </Button>
                    <Button
                      //disabled={importData == undefined || importData.length == 0}
                      className="submit-button"
                      onClick={close}
                    >
                      Close
                    </Button>
                  </>
                </Row>
              ) : (
                <Row className="spinner-container">
                  <CFASpinner />
                </Row>
              )}
            </CardFooter>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );

  const submissionSuccess = (
    <Col className="success-container">
      <img alt="" src={success} className="success-icon" />
      <h4>{I18n.t("RISK_ANALYSIS_SAVE_SUCCESS")}</h4>
      <Button className="go-back-button" block onClick={closeSuccess}>
        {I18n.t("APP_ARMORED_CAR_IMPORT_FILE_CLOSE")}
      </Button>
    </Col>
  );

  return (
    <>
      <Col className="RiskInformationMultiSelectModal container">
        {/*{saveForm}*/}
        {!errorStatus.includes("succeeded") ? (
          <> {saveForm} </>
        ) : (
          <> {submissionSuccess} </>
        )}
      </Col>
    </>
  );
}
export default RiskInformationSaveModal;
